// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.module-authorization-frame {
  line-height: 0;
  font-size: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Authorization/less/index.less"],"names":[],"mappings":"AAGI;EACI,cAAA;EACA,YAAA;AAFR","sourcesContent":["@import (reference) \"../../../less/variables\";\n\n.module-authorization {\n    &-frame {\n        line-height: 0;\n        font-size: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
